import React from 'react';
import {Button} from 'reactstrap';
import Icon from '../../shared/Icon.tsx';
import {GoogleDriveBrandIcon} from '../../shared/customIcons.ts';

interface GoogleDriveUploadPickerProps {
    openPicker: () => void;
}

const GoogleDriveUploadPicker: React.FC<GoogleDriveUploadPickerProps> = ({
    openPicker
}) => {
    return (
        <div style={{textAlign: 'center'}}>
            <Button
                color="primary"
                onClick={() => openPicker()}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}
            >
                <Icon icon={GoogleDriveBrandIcon} size={50} />
                <span
                    style={{
                        marginTop: 10
                    }}
                >
                    Upload from Google Drive
                </span>
            </Button>
        </div>
    );
};

export default GoogleDriveUploadPicker;
